import { ca } from '@cian/analytics';

export enum EMoreMenuItems {
  Print = 'hide_from_print',
  Pdf = 'download_pdf',
  Doc = 'download_doc',
}

export function trackMoreMenuItemClick(menuItem: EMoreMenuItems) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: `moreMenu_${menuItem}`,
  });
}
